import { IDoPos, IPitch, IScore } from "../types";

const clefTypes = {
    treble: 6,
    bass: -10,
};
const solfaParser = [3, 0, 4, 1, 5, 2, 6];
const getAbsolutePosition = (p: IPitch, clef: "treble" | "bass", doPos: IDoPos, octave: number) => {
    let rn = solfaParser[p.s] + p.o! * 7 + (((doPos.i + 14) * 4) % 7) + (doPos.o + octave) * 7;
    let clefDistance = clefTypes[clef] + 28;
    let notePos = clefDistance - rn;
    return notePos;
};

const getDoPosition = (type: "treble" | "bass", score: IScore, voice: IScore["voice"]) => {
    return getAbsolutePosition({ s: 1, o: 0, a: 0 }, type, score.doPos, score["octave" + voice] || 0);
};

export default getDoPosition;
